<template>
  <div class="g-page-container">

    <div class="g-pageHeader" style="height: 63px;">
      <h1 style="margin: auto;">{{$t('configRecip.title')}}</h1>
    </div>

    <form class="g-pageBody" @submit.prevent="onSubmit">

      <div class="form-group">
        <label for="inputName">{{$t('configRecip.name')}}</label>
        <input
          type="text"
          required
          v-model="smsRecipient.name"
          class="form-control"
          id="inputName"
          :placeholder="$t('configRecip.namePHolder')">
      </div>

      <div class="form-group">
        <label for="inputPhone">{{$t('configRecip.phone')}}</label>
        <input
          type="text"
          required
          v-model="smsRecipient.phone"
          class="form-control"
          id="inputPhone"
          :placeholder="$t('configRecip.phonePHolder')">
      </div>

      <div class="form-group">
        <input type="checkbox" id="isActive" v-model="smsRecipient.isActive">
        <label class="checkboxLabel" for="isActive">{{$t('configRecip.active')}}</label>
      </div>

      <button class="btn btn-perfcell float-left marginTop50px" @click.prevent="clickRetour">
        {{ $t('configRecip.cancel' ) }}
      </button>

      <button class="btn btn-perfcell float-left marginTop50px marginLeft10px" type="submit">
        {{ $t('configRecip.submit' ) }}
      </button>

      <p v-if="errors.length" class="float-left marginTop50px marginLeft30px" :style="{ color: msgColor }">
        <b v-if="msgColor == 'red'">{{$tc('configRecip.error', errors.length)}}</b>
        <ul>
          <li v-for="error in errors" :key="error">{{ error }}</li>
        </ul>
      </p>

    </form>

  </div>
</template>

<script>
import { axiosInstance } from "@/main";

export default {
  data() {
    return {
      smsRecipient: {
        _id: '',
        name: '',
        phone: '',
        isActive: true
      },
      id: '',
      errors: [],
      msgColor: "red"
    }
  },
  methods: {
    onSubmit() {
      if( ! this.validate() )
        return;
      axiosInstance.post('/smsRecipient/' + this.id, this.smsRecipient)
      .then((resp) => {
        //console.log("----- onSubmit ok = " + JSON.stringify(resp.data, null, 2));

        this.smsRecipient = resp.data;
        this.id = this.smsRecipient._id;
        this.errors.push(this.$i18n.t('configRecip.success'));
        this.msgColor = "green";
      }).catch((err) => {
        console.log("----- onSubmit error = " + JSON.stringify(err, null, 2));
      });
    },
    validate() {
      this.errors = [];
      this.msgColor = "red";

      this.smsRecipient.name = this.smsRecipient.name.trim();
      if( ! this.smsRecipient.name.length )
        return false;

      this.smsRecipient.phone = this.smsRecipient.phone.trim();
      if( ! this.smsRecipient.phone.length )
        return false;

      let phoneRGEX = new RegExp(/^[(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/);
      if( ! phoneRGEX.test( this.smsRecipient.phone ) ) {
        this.errors.push(this.$i18n.t('configRecip.validPhone'));
      }
      else {
        // reformat like this : "999 999-9999"
        let cleaned = ('' + this.smsRecipient.phone).replace(/\D/g, '');
        let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
        if( match ) {
          this.smsRecipient.phone = match[1] + ' ' + match[2] + '-' + match[3];
        }
      }

      return ! this.errors.length;
    },
    clickRetour() {
      this.$router.replace("/configSmsRecipientsList");
    }
  },
  mounted() {
    if( this.id != "0" ) {
      axiosInstance.get('/smsRecipient/' + this.id)
      .then(resp => {
        //console.log("----- get /smsRecipient = " + JSON.stringify(resp.data, null, 2));
        this.smsRecipient = resp.data;
      })
      .catch(err => {
        console.log("----- get /smsRecipient error = " + JSON.stringify(err, null, 2));
      });
    }
  },
  created() {
    this.id = this.$route.params.id;
    //console.log("----- this.id = " + JSON.stringify(this.id, null, 2));
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/colors.scss';

form {
  background: White;
  padding: 2rem 2rem 1rem;
  width: 100%;
}

label {
  font-weight: bold;
}

.narrow {
  width: 70px;
}
</style>
